import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

import { KomponentType } from "../model/komponent-type.model";

@Component({
    selector: "komponent-typer",
    templateUrl: "./komponent-typer.component.html",
    styleUrls: ["./komponent-typer.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KomponentTyperComponent {
    @Input() public komponentTyper: KomponentType[];
    @Output() public vaelg = new EventEmitter<KomponentType>();

    public hentKanFaktureresTekst(kanDenFaktureres: boolean): string {
        return kanDenFaktureres ? "(Fakturerbar)" : "";
    }
}
